export default __webpack_public_path__ + "wp-content/uploads/react/user-dashboard/media/logoFOOD.5ae1de19.svg";